import { render, staticRenderFns } from "./sounds.vue?vue&type=template&id=10cd055c"
import script from "./sounds.vue?vue&type=script&lang=js"
export * from "./sounds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports